/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDRadiusUpRightIcon24Solid = forwardRef('ArrowDRadiusUpRightIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M16.31 2.84a1.5 1.5 0 1 0-2.12 2.12L18.228 9H12.5C6.701 9 2 13.701 2 19.5v1a1.5 1.5 0 0 0 3 0v-1a7.5 7.5 0 0 1 7.5-7.5h5.729l-4.04 4.04a1.5 1.5 0 1 0 2.122 2.12l5.185-5.185a3.5 3.5 0 0 0 0-4.95l-5.185-5.186Z" })));
});
